import CartDetailedSectionHeaderComponent from "./CartDetailedSectionHeader.Component";

export default CartDetailedSectionHeaderComponent;
